import * as React from 'react';

import i18n from 'src/translation/i18n';
import samsungLogo from '../../assets/samsung';
import env from 'src/shared/env';
import {
  SamsungOrderInvoiceSearchForm,
  SamsungOrderInvoiceResultTable
} from 'src/components/SamsungOrderInvoiceSearchFormTable';
import './SamsungOrderInvoiceView.scss';
import { IInitialState } from 'src/store/initialState';
import SamsungOrderInvoiceModel from 'src/model/samsungOrderInvoice.model';
import SamsungOrderInvoiceViewModel from 'src/model/modules/samsungOrderInvoiceView.model';
import { IPaginationSamsungOrderInvoice } from 'src/services/samsungOrderInvoices/samsungOrderInvoicesService';

interface ISamsungOrderInvoiceProps {
  samsungOrderInvoiceForm: SamsungOrderInvoiceViewModel;
  pageInformation: any;
  searchSamsungOrdersAndInvoices(request: any, pagination: any): void;
  exportSamsungOrdersAndInvoices(request: any): void;
}

export class SamsungOrderInvoice extends React.Component<
  ISamsungOrderInvoiceProps,
  IInitialState
> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const paginationRequest = {
      page: 0,
      size: this.props.pageInformation.pageSize
    };
    return (
      <div>
        <div className="rp-samsungOrderContainer">
          <div className="rp-samsungOrderInner">
            <div className="title-wrapper">
              <img className="image-icon" src={samsungLogo} />
              <h1 className="page-title">
                {' '}
                {i18n.t('samsungOrder.pageTitle')}{' '}
              </h1>
            </div>
            <SamsungOrderInvoiceSearchForm
              samsungOrderInvoiceForm={this.props.samsungOrderInvoiceForm}
              searchOrdersAndInvoices={
                this.props.searchSamsungOrdersAndInvoices
              }
              paginationRequest={paginationRequest}
            />
          </div>
          <SamsungOrderInvoiceResultTable
            samsungOrderInvoiceForm={this.props.samsungOrderInvoiceForm}
            searchSamsungOrdersAndInvoices={
              this.props.searchSamsungOrdersAndInvoices
            }
            exportSamsungOrdersAndInvoices={
              this.props.exportSamsungOrdersAndInvoices
            }
          />
        </div>
      </div>
    );
  }
}

export default SamsungOrderInvoice;
